import styled from 'styled-components'

const sizes = { small: 1366, medium: 1600 }

const scale = { medium: 0.85, small: 0.7 }

const titleWidth = 200
const titleHeight = 30

const topMargin = -15
const topMarginHover = -17
const leftMargin = -32
const leftMarginHover = -30

const imageWidth = 170
const imageHeight = 170

const countWidth = 95
const countHeight = 35

const fontSize = 1.5
const fontSizeCount = 1.5

export const TitleBackground = styled.div`
  position: absolute;
  top: ${topMargin}px;
  left: ${leftMargin}px;

  display: block;
  width: ${titleWidth}px;
  height: ${titleHeight}px;

  color: #e6f2fe;
  background: rgba(5, 75, 130, 1);
  z-index: 4;
  clip-path: polygon(0% 0,100% 9%,98% 95%,4% 96%);
  transform: rotate(-7deg) scaleX(0.85);
  transition: 0.1s;
  user-select: none;

  @media screen and (max-width: ${sizes.medium}px){
    top: ${topMargin * scale.medium}px;
    left: ${leftMargin * scale.medium}px;

    width: ${titleWidth * scale.medium}px;
    height: ${titleHeight * scale.medium}px;
  }

  @media screen and (max-width: ${sizes.small}px){
    top: ${topMargin * scale.small}px;
    left: ${leftMargin * scale.small}px;

    width: ${titleWidth * scale.small}px;
    height: ${titleHeight * scale.small}px;
  }
`

export const Title = styled.div`
  position: absolute;
  top: ${ props => props.selected ? `${topMarginHover}px` : `${topMargin}px` };
  left: ${ props => props.selected ? `${leftMarginHover}px` : `${leftMargin}px` };

  display: flex;
  width: ${titleWidth}px;
  height: ${titleHeight}px;
  justify-content: center;
  align-items: center;

  text-decoration: none;
  font-family: 'Crash';
  text-align: center;
  font-size: ${fontSize}em;
  transform: rotate(-7deg) scaleX(0.85);
  color: ${ props => props.selected ? "#054b82" : "#60b2e1" };
  background: ${ props => props.selected ? "rgba(219, 239, 245, 1)" : "" };
  z-index: ${ props => props.selected ? 7 : 4 };
  clip-path: ${ props => props.selected ? 'polygon(0% 0,100% 9%,98% 95%,4% 96%)' : 'polygon(0% 0,100% 9%,98% 95%,4% 96%)' };
  transition: 0.1s;
  user-select: none;

  @media screen and (max-width: ${sizes.medium}px){
    top: ${ props => props.selected ? `${topMarginHover * scale.medium}px` : `${topMargin * scale.medium}px` };
    left: ${ props => props.selected ? `${leftMarginHover * scale.medium}px` : `${leftMargin * scale.medium}px` };

    width: ${titleWidth * scale.medium}px;
    height: ${titleHeight * scale.medium}px;

    font-size: ${fontSize * scale.medium}em;
  }

  @media screen and (max-width: ${sizes.small}px){
    top: ${ props => props.selected ? `${topMarginHover * scale.small}px` : `${topMargin * scale.small}px` };
    left: ${ props => props.selected ? `${leftMarginHover * scale.small}px` : `${leftMargin * scale.small}px` };

    width: ${titleWidth * scale.small}px;
    height: ${titleHeight * scale.small}px;

    font-size: ${fontSize * scale.small}em;
  }
`

export const ImageBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  display: block;
  width: ${imageWidth}px;
  height: ${imageHeight}px;

  color: #e6f2fe;
  background: rgba(5, 75, 130, .7);
  z-index: 1;
  clip-path: polygon(0 0, 100% 0, 98% 100%, 0 97%);
  transition: 0.1s;
  user-select: none;

  @media screen and (max-width: ${sizes.medium}px){
    width: ${imageWidth * scale.medium}px;
    height: ${imageHeight * scale.medium}px;
  }

  @media screen and (max-width: ${sizes.small}px){
    width: ${imageWidth * scale.small}px;
    height: ${imageHeight * scale.small}px;
  }

  ${props => props.selected && `
    border-right: solid 8px rgba(0, 0, 0, 0.1);
    background-clip: padding-box;
  `}
`

export const Image = styled.div`
  position: absolute;
  top: ${ props => props.selected ? '-3px' : '0' };
  left: ${ props => props.selected ? '3px' : '0' };

  display: block;
  width: ${imageWidth}px;
  height: ${imageHeight}px;
  justify-content: center;
  align-items: center;
  user-select: none;

  background: ${ props => props.selected ? "rgba(219, 239, 245, 1)" : "" };
  z-index: ${ props => props.selected ? 3 : 2 };
  clip-path: ${ props => props.selected ? 'polygon(0 0, 100% 0, 98% 100%, 0 97%)' : 'polygon(0 0, 100% 0, 98% 100%, 0 97%)' };
  transition: 0.1s;

  @media screen and (max-width: ${sizes.medium}px){
    width: ${imageWidth * scale.medium}px;
    height: ${imageHeight * scale.medium}px;
  }

  @media screen and (max-width: ${sizes.small}px){
    width: ${imageWidth * scale.small}px;
    height: ${imageHeight * scale.small}px;
  }

  > img {
    display: block;
    width: 100%;
    height: 100%;
    transition: 0.1s;
  }

  ${props => props.selected && `
    > img {
      transform: scale(1.05)
    }
  `}
`

export const Count = styled.div`
  position: absolute;
  bottom: 1em;
  left:28%;
  user-select: none;

  display: flex;
  width: ${countWidth}px;
  height: ${countHeight}px;
  justify-content: center;
  align-items: center;

  text-decoration: none;
  font-family: 'Barthowheel-Regular';
  text-align: center;
  font-size: ${fontSizeCount}em;
  color: #60b2e1;
  background: rgba(5, 75, 130, 1);
  z-index: 6;
  clip-path: polygon(0% 14%, 97% 0%, 94% 95%, 0% 87%);
  transform: scaleX(0.85);

  @media screen and (max-width: ${sizes.medium}px){
    width: ${countWidth * scale.medium}px;
    height: ${countHeight * scale.medium}px;

    font-size: ${fontSizeCount * scale.medium}em;
  }

  @media screen and (max-width: ${sizes.small}px){
    width: ${countWidth * scale.small}px;
    height: ${countHeight * scale.small}px;

    font-size: ${fontSizeCount * scale.small}em;
  }
`

export const Item = styled.div`
  position: relative;
  width: ${imageWidth}px;
  height: ${(imageHeight + titleHeight)}px;

  cursor: pointer;
  user-select: none;

  &:nth-child(n+5){
    grid-area: second;
  }

  @media screen and (width: 812px) and (orientation: landscape){
    &:nth-child(n){
      grid-area: unset;
    }
  }

  @media screen and (max-width: ${sizes.medium}px){
   width: ${imageWidth * scale.medium}px;
    height: ${(imageHeight + titleHeight) * scale.medium}px;
  }

  @media screen and (max-width: ${sizes.small}px){
    width: ${imageWidth * scale.small}px;
    height: ${(imageHeight + titleHeight) * scale.small}px;
  }

  &:hover ${Title}{
    top: ${topMarginHover}px;
    left: ${leftMarginHover}px;
    color: #054b82;
    background: rgba(219, 239, 245, 1);
    /* clip-path: polygon(2% 0, 100% 12%, 99% 82%, 0 100%); */
    z-index: 7;
    transition: 0.1s;


    @media screen and (max-width: ${sizes.medium}px){
      top: ${topMarginHover * scale.medium}px;
      left: ${leftMarginHover * scale.medium}px;
    }

    @media screen and (max-width: ${sizes.small}px){
      top: ${topMarginHover * scale.small}px;
      left: ${leftMarginHover * scale.small}px;
    }
  }

  &:hover ${Image}{
    top: -3px;
    left: 3px;
    background: rgba(219, 239, 245, 1);
    /* clip-path: polygon(0 0, 100% 0, 98% 100%, 0 97%); */
    z-index: 3;
    transition: 0.1s;

    > img{
      transform: scale(1.05);
    }
  }
`